import React, { createContext, useState, useContext, useRef } from 'react';
import ReusableDialog from './ReusableDialog';
import { IoWarning, IoInformationCircle } from 'react-icons/io5';
const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    show: false,
    title: '',
    message: '',
    onPrimaryAction: null,
    onSecondaryAction: null,
    primaryActionText: '',
    secondaryActionText: '',
    iconDisplay: IoWarning,
    iconColor: '#f0ad4e',
    onClose: null,
  });

  //Sample Usage for Open of Subscription Dialog
  // openDialog({
  //   title: 'You are out of credits!',
  //   message: 'You don’t have enough credits to access this power tool. Please subscribe to continue using this feature. Would you like to request approval from your supervisor?',
  //   onPrimaryAction: () => console.log('Subscribed'),
  //   primaryActionText: 'Request Approval',
  // });
  const openDialog = ({ title, message, onPrimaryAction, onSecondaryAction, primaryActionText, secondaryActionText, iconType, iconColor, onClose }) => {
    setDialogState({
      show: true,
      title,
      message,
      onPrimaryAction,
      onSecondaryAction,
      primaryActionText,
      secondaryActionText,
      iconDisplay: iconType === 'warning' ? IoWarning : IoInformationCircle,
      iconColor,
      onClose,
    });
  };
  const isClosingRef = useRef(false);
  const closeDialog = () => {
    if (isClosingRef.current) return;
    isClosingRef.current = true;
    if (typeof dialogState.onClose === 'function') {
      dialogState.onClose();
    }
    setDialogState((prevState) => ({ ...prevState, show: false }));
  };
  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      <ReusableDialog
        show={dialogState.show}
        title={dialogState.title}
        message={dialogState.message}
        onClose={closeDialog}
        onPrimaryAction={dialogState.onPrimaryAction}
        primaryActionText={dialogState.primaryActionText}
        secondaryActionText={dialogState.secondaryActionText}
        iconDisplay={dialogState.iconDisplay}
        iconColor={dialogState.iconColor}
        onSecondaryAction={dialogState.onSecondaryAction}
      />
    </DialogContext.Provider>
  );
};
